module.exports = __webpack_public_path__ + "img/person.94d3eedd.svg";